import { render, staticRenderFns } from "./NotFoundPage.html?vue&type=template&id=fe82e6e8&scoped=true&"
import script from "./NotFoundPage.ts?vue&type=script&lang=ts&"
export * from "./NotFoundPage.ts?vue&type=script&lang=ts&"
import style0 from "./NotFoundPage.scss?vue&type=style&index=0&id=fe82e6e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe82e6e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
